// import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
  Box,
  Flex,
  Heading,
  Spinner,
  Button,
  useToast,
  // Text,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  newBorder,
  primary,
  white,
  textSecondary,
  buttonRed,
  buttonRedText,
} from "../../../../utils/colors";
import ToastComponent from "../../../../components/partials/ToastComponent";
import { useTranslation } from "react-i18next";
// import SidePanel from "../../../../components/sidepanelNew/SidePanel";
// import useRoleCheck from "../../../../hooks/useRoleCheck";
import { useLocation, useParams, Link } from "react-router-dom";
import useThemeColors from "../../../../hooks/useThemeColors";
import useScrollToTop from "../../../../hooks/useScrollToTop";
// import FormControlGender from "../../../../components/input/FormControlGender";
// import FormControlDefault from "../../../../components/input/FormControlDefault";
// import FormControlDatePicker from "../../../../components/input/FormControlDatePicker";
import ClinicCompanyDetails from "./partials/ClinicCompanyDetails";
import ClinicLogo from "./partials/ClinicLogo";
import ClinicDetails from "./partials/ClinicDetails";
// import ClinicSenderIdentities from "./partials/ClinicSenderIdentities";
import ClinicRegionalSettings from "./partials/ClinicRegionalSettings";
import ClinicSchedulingSettings from "./partials/ClinicSchedulingSettings";
import ClinicWorkingHours from "./partials/ClinicWorkingHours";
import ClinicDentalChairs from "./partials/ClinicDentalChairs";
import ClinicDefaultEmployeeTreatmentPlans from "./partials/ClinicDefaultEmployeeTreatmentPlans";
import UserNoAccess from "../../../../components/partials/UserNoAccess";
import { useEffect, useState } from "react";
import {
  deactivateTenantAccountAction,
  deleteTenantAccountAction,
} from "../../../../actions/tenantActions";
import ConfirmDeleteModal from "../../../../components/modals/ConfirmDeleteModal";

const ClinicSettings = () => {
  useScrollToTop();

  // GENERAL
  const { slug } = useParams();
  const dispatch = useDispatch();
  const toastComponent = ToastComponent();
  const { t } = useTranslation();
  const toast = useToast();
  const location = useLocation();

  // LANGUAGE
  const storedLanguage = localStorage.getItem("language");
  const initialLanguage = storedLanguage || "lt"; // Default to 'en'
  const [currentLanguage, setCurrentLanguage] = useState(initialLanguage);

  // STATE
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  // COLORS
  const { whiteMode, backgroundLightMode, textPrimaryMode, newBorderMode } =
    useThemeColors();

  // ROLES
  // const isDoctor = useRoleCheck("employee_doctor");
  // const isAdmin = useRoleCheck("admin");

  // TAB BUTTONS
  // Button details for mapping
  const buttonDetails = [
    {
      label: t("clinicSettings.clinicInfo"),
      link: `/${slug}/settings/clinic-settings`,
      isDisabled: false,
    },
    {
      label: t("clinicSettings.activeModules"),
      link: `/${slug}/settings/clinic-settings/active-modules`,
      isDisabled: false,
    },
    {
      label: t("clinicSettings.paymentsInvoices"),
      link: `/${slug}/settings/clinic-settings/payments-and-invoices`,
      isDisabled: false,
    },
    {
      label: t("clinicSettings.tenantUsers"),
      link: `/${slug}/settings/clinic-settings/users`,
      isDisabled: false,
    },
  ];

  // STATE

  //  SIDEPANELS

  // REDUX
  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const tenantDetailsBySlug = useSelector((state) => state.tenantDetailsBySlug);
  const { tenant } = tenantDetailsBySlug;

  const tenantDeleteAccount = useSelector((state) => state.tenantDeleteAccount);
  const {
    loading: deleteLoading,
    error: deleteError,
    success: deleteSuccess,
  } = tenantDeleteAccount;

  // HANDLERS

  const handleDeleteTenant = () => {
    dispatch(deactivateTenantAccountAction(slug, currentLanguage));
  };

  // FETCH DATA

  // USEEFFECT

  // CHECK PERMISSIONS

  const currentTenantSlug = slug || tenant?.slug;

  // 1. Get permissions for current tenant
  const currentTenantAccess = userInfo?.tenants?.find(
    (t) => t.slug === currentTenantSlug
  );

  const hasAccess = currentTenantAccess?.permissions?.settings?.on;
  // const hasAccessToCreate = currentTenantAccess?.permissions?.patients?.create;

  useEffect(() => {
    // Early exit if permissions are not loaded yet
    if (!currentTenantAccess?.permissions) return;

    const perms = currentTenantAccess.permissions;

    if (perms.settings?.on) return; // ✅ allowed, stay on dashboard
  }, [currentTenantAccess, slug]);

  if (hasAccess === false)
    return (
      <>
        <UserNoAccess pageName={t("noAccess.clinicSettings")} />
      </>
    );

  const isOwner = userInfo.email === tenant?.registrationEmail;

  // LOGS
  // console.log("location.pathname", location.pathname);

  return (
    <>
      {/* HELMET START */}
      <Helmet>
        <title>{t("pageTitle.clinicSettings")}</title>
        <meta
          name="description"
          content={t("pageDescription.clinicSettings")}
        />
      </Helmet>
      {/* HELMET END */}

      {/* SIDEPANELS  START */}

      {/* SIDEPANELS  END */}

      {/* MODALS START */}
      {showDeleteConfirmation && (
        <ConfirmDeleteModal
          hasAccessToDelete={true}
          // noAccessPageName={t("noAccess.employeeDelete")}
          deleteTitle={t("user.deleteTenantAccount")}
          // deleteName={employeeName}
          warningLabel={t("user.deleteTenantAccountWarning")}
          // warningLabel={
          //   employeeIsCoordinatorInPlans === true
          //     ? t("employee.deleteWarningEmployeeInPlans")
          //     : t("employee.deleteWarning")
          // }
          isOpen={showDeleteConfirmation}
          onClose={() => setShowDeleteConfirmation(false)}
          confirmAction={() => {
            handleDeleteTenant();
            setShowDeleteConfirmation(false);
          }}
        />
      )}
      {/* MODALS END */}

      {/* MAIN START */}
      {tenant ? (
        <Box w="100%" minH="100%" pt={["80px", "80px"]}>
          <Flex
            direction="column"
            w="100%"
            p={["0rem 0rem 6rem", "2rem 2rem 6rem"]}
          >
            <Box
              w="100%"
              h="100%"
              bg={whiteMode}
              // overflow="hidden"
              borderRadius="2rem"
            >
              {/* HEADER START */}
              <Flex
                w="100%"
                direction="column"
                p={["0rem 0rem 1rem", "0rem 2rem 1rem"]}
                m="0 0 0rem"
                borderBottom={`1px solid ${newBorder}`}
              >
                <Flex
                  w="100%"
                  align="center"
                  justify="space-between"
                  borderBottom={`0px solid ${newBorder}`}
                  p={["1.5rem 0rem 0.5rem", "2rem 0rem 0.5rem"]}
                >
                  <Heading
                    fontSize="1.25rem"
                    fontWeight="600"
                    p={["0 0 0 1.5rem", "initial"]}
                  >
                    {t("clinicSettings.clinicSettings")}
                  </Heading>
                </Flex>

                {/* TABS */}
                <Flex
                  w="100%"
                  gap="1rem"
                  m="1rem 0 0"
                  overflow={["hidden", "initial"]}
                  p={["0 0 0 1.5rem", "initial"]}
                >
                  {buttonDetails.map((button, index) => {
                    const isActive = location.pathname === button.link;

                    return (
                      <Link to={button.link} key={index}>
                        <Button
                          variant="primary"
                          size="sm"
                          h="2.5rem"
                          px="1.5rem"
                          bg={isActive ? textPrimaryMode : backgroundLightMode}
                          color={isActive ? white : textSecondary}
                          borderRadius="1rem"
                          fontWeight="500"
                          isDisabled={button.isDisabled}
                          _hover={{
                            bg: isActive ? textPrimaryMode : "gray.100",
                            color: isActive ? white : textSecondary,
                          }}
                        >
                          {button.label}
                        </Button>
                      </Link>
                    );
                  })}
                </Flex>
              </Flex>
              {/* HEADER END */}

              {/* MAIN LAYOUT START */}
              <Flex
                w="100%"
                direction="column"
                p={["0 0rem 8rem", "0 2rem 8rem"]}
              >
                <ClinicLogo slug={slug} tenant={tenant} />
                <ClinicDetails slug={slug} tenant={tenant} />
                <ClinicCompanyDetails slug={slug} tenant={tenant} />
                {/* <ClinicSenderIdentities tenant={tenant} /> */}
                <ClinicRegionalSettings slug={slug} tenant={tenant} />
                <ClinicSchedulingSettings slug={slug} tenant={tenant} />
                <ClinicWorkingHours slug={slug} tenant={tenant} />
                <ClinicDentalChairs slug={slug} tenant={tenant} />
                <ClinicDefaultEmployeeTreatmentPlans
                  slug={slug}
                  tenant={tenant}
                />

                {isOwner && (
                  <Flex
                    w="100%"
                    align="center"
                    justify="flex-end"
                    p={["2rem 1.5rem 0", "2rem 0 0"]}
                  >
                    <Button
                      size="lg"
                      fontSize="sm"
                      bg={buttonRed}
                      color={buttonRedText}
                      borderRadius="10rem"
                      fontWeight="500"
                      onClick={() => setShowDeleteConfirmation(true)}
                      _hover={{
                        bg: textPrimaryMode,
                        color: white,
                      }}
                    >
                      {t("user.deleteClinic")}
                    </Button>
                  </Flex>
                )}
              </Flex>
              {/* MAIN LAYOUT  END */}
            </Box>
          </Flex>
        </Box>
      ) : (
        <Flex w="100%" h="100vh" align="center" justify="center">
          <Spinner size="xl" color={primary} />
        </Flex>
      )}
      {/* MAIN END */}
    </>
  );
};

export default ClinicSettings;
